import './App.css';
import Navbar from './Components/Navbar/Navbar';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Shop from './Pages/Shop';
import ShopCategory from './Pages/ShopCategory';
import Product from './Pages/Product';
import Cart from './Pages/Cart';
import LoginRegister from './Pages/LoginRegister';
import Footer from './Components/Footer/Footer';
import OrderConfirm from './Components/OrderConfirm/OrderConfirm'
import OrderSuccess from './Components/OrderSuccess/OrderSuccess';
import ShopProducts from './Pages/ShopProducts';
import AlertBanner from './Components/AlertBanner/AlertBanner'
import MyOrders from './Components/MyOrders/MyOrders';
import PrivacyPolicy from './Components/TermsAndConditions/Privacypolicy';
import TermsAndConditions from './Components/TermsAndConditions/Termsandconditions';
import { useEffect } from 'react'

const ScrollToTop = () => {
    const { pathname } = useLocation()
    useEffect(() => { window.scrollTo(0, 0) }, [pathname])
    return null
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop/>
        <AlertBanner/>
        <Navbar/>
        <div className="content">
        <Routes>
          <Route path="/" element={<Shop/>} />
          <Route path="/shop-products" element={<ShopProducts />} />
          <Route path='/mens' element={<ShopCategory category="men"/>} />
          <Route path='/womens' element={<ShopCategory category="women"/>} />
          <Route path='/kids' element={<ShopCategory category="kid"/>} />
          <Route path='/other' element={<ShopCategory category="other"/>} />
          <Route path="/product" element={<Product/>}>
            <Route path=':productid' element={<Product/>} />
          </Route>
          <Route path='/cart' element={<Cart/>} />
          <Route path='login' element={<LoginRegister/>} />
          <Route path='/checkout' element={<OrderConfirm/>}/>
          <Route path="/order-success" element={<OrderSuccess />} />
          <Route path="/profile/orders" element={<MyOrders/>} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        </Routes>
        </div>
        <Footer/>
      </BrowserRouter>
    </div>
  );
}

export default App;
